class WorkshopReview {
  constructor(id, isAuthor, name, rate, content, make, model, releasedDate, reported) {
    this.id = id;
    this.isAuthor = isAuthor;
    this.name = name;
    this.rate = rate;
    this.content = content;
    this.make = make;
    this.model = model;
    this.releasedDate = releasedDate;
    this.reported = reported;
  }
}

export default WorkshopReview;
